export default {
    skinning: {
        dataAttributeName : "skinning",
        dataAttributes : {
            "hrX": "hrx",
            "Worklife": "WorkLife",
            "default": "WorkLife",
            "embedded": "embedded",
        },
        defaultSkin : "WorkLife",
        rootSelector : "#nit-alme-window-root",
    },
};



// WEBPACK FOOTER //
// ./settings/skinning.ts